var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { width: _vm.inputSize }, attrs: { id: "input" } },
    [
      _c("div", { staticClass: "title" }, [
        _c("label", [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-container", attrs: { tabindex: "0" } }, [
        _vm.type === "checkbox" && _vm.inputMask
          ? _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: _vm.inputMask,
                  expression: "inputMask",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cloneValue,
                  expression: "cloneValue",
                },
              ],
              attrs: { placeholder: _vm.placeHolder, type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.cloneValue)
                  ? _vm._i(_vm.cloneValue, null) > -1
                  : _vm.cloneValue,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.cloneValue,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.cloneValue = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.cloneValue = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.cloneValue = $$c
                  }
                },
              },
            })
          : _vm.type === "radio" && _vm.inputMask
          ? _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: _vm.inputMask,
                  expression: "inputMask",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cloneValue,
                  expression: "cloneValue",
                },
              ],
              attrs: { placeholder: _vm.placeHolder, type: "radio" },
              domProps: { checked: _vm._q(_vm.cloneValue, null) },
              on: {
                change: function ($event) {
                  _vm.cloneValue = null
                },
              },
            })
          : _vm.inputMask
          ? _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: _vm.inputMask,
                  expression: "inputMask",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cloneValue,
                  expression: "cloneValue",
                },
              ],
              attrs: { placeholder: _vm.placeHolder, type: _vm.type },
              domProps: { value: _vm.cloneValue },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.cloneValue = $event.target.value
                },
              },
            })
          : _vm.type === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cloneValue,
                  expression: "cloneValue",
                },
              ],
              attrs: { placeholder: _vm.placeHolder, type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.cloneValue)
                  ? _vm._i(_vm.cloneValue, null) > -1
                  : _vm.cloneValue,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.cloneValue,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.cloneValue = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.cloneValue = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.cloneValue = $$c
                  }
                },
              },
            })
          : _vm.type === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cloneValue,
                  expression: "cloneValue",
                },
              ],
              attrs: { placeholder: _vm.placeHolder, type: "radio" },
              domProps: { checked: _vm._q(_vm.cloneValue, null) },
              on: {
                change: function ($event) {
                  _vm.cloneValue = null
                },
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cloneValue,
                  expression: "cloneValue",
                },
              ],
              attrs: { placeholder: _vm.placeHolder, type: _vm.type },
              domProps: { value: _vm.cloneValue },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.cloneValue = $event.target.value
                },
              },
            }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }